import type { PaginatedResponse, PreordersTableRow } from '@ekhodealer/ekho-common';
import type { QueryClient } from '@tanstack/react-query';

import { preorders } from './queryKeys';

/**
 * Updates a preorder's status in all cached search queries after a successful mutation.
 */
export const updatePreorderStatusInCache = ({
	queryClient,
	preorderId,
	newDisplayStatus,
}: {
	queryClient: QueryClient;
	preorderId: string;
	newDisplayStatus: string;
}): void => {
	const cache = queryClient.getQueriesData<PaginatedResponse<PreordersTableRow>>({
		queryKey: preorders._def,
	});

	for (const [queryKey, data] of cache) {
		if (!data?.data) continue;

		const index = data.data.findIndex((row) => row.preorderId === preorderId);
		if (index === -1) continue;

		const updatedRows = [...data.data];
		updatedRows[index] = { ...updatedRows[index], status: newDisplayStatus };

		queryClient.setQueryData(queryKey, {
			...data,
			data: updatedRows,
		});
	}
};
